import * as ActionTypes from '../constants/ActionTypes'
import {TOGGLE_SELECTION_TRIGGERED} from '../constants/ActionTypes'
import {OUTSOURCING_ADDPROJECT} from "../constants/General";
import {delve} from "../util/util";

// **************************************************************************************************************
export const articleDataReducer = (state = {baseArticle: {}, articleOptions: {}, articleOptionCollection: {}}, action) => {

    switch (action.type) {

        case TOGGLE_SELECTION_TRIGGERED:
            if (action && action.selectedContentId === OUTSOURCING_ADDPROJECT) {

                return Object.assign({}, state, {baseArticle: {}});

            } else {
                return state;
            }

        case ActionTypes.BASE_ARTICLE_SUCCESS:
            if (action.response && action.response.entities) {

                const baseArticleData = action.response.entities.article.baseArticle;

                baseArticleData.limits = baseArticleData.configurationData && baseArticleData.configurationData.limits;

                const articleOptionCollection = action.response.entities.articleOptionCollection;
                const baseHddSwGroup = articleOptionCollection && articleOptionCollection[baseArticleData.articleNumber].hardware && articleOptionCollection[baseArticleData.articleNumber].hardware.hddSw

                // modify action.response.entities.articleOptionGroup and add default hdd-sw article

                if (baseArticleData.type === 'vserver' || baseArticleData.type === 'shared') {
                    if (
                        baseHddSwGroup
                    ) {
                        articleOptionCollection[baseArticleData.articleNumber].hardware.hddSw = ["default_hddSw", ...baseHddSwGroup];
                        action.response.entities.articleOption = Object.assign(
                            action.response.entities.articleOption,
                            {
                                "default_hddSw": {
                                    default: true,
                                    title: Math.round(baseArticleData.projectSpace / 1024 / 1024) + " GB Speicherplatz",
                                    price: {default: {setupFee: 0, priceMonthly: 0, net: 0}},
                                    /*inclusiveLabel: "Standardvolumen"*/
                                }
                            }
                        )
                    }
                }

                if (delve(baseArticleData, 'description.default.title')) {
                    baseArticleData.title = baseArticleData.description.default.title;
                }

                if (delve(baseArticleData, 'description.default.text')) {
                    baseArticleData.description = baseArticleData.description.default.text;
                }

                // merge articleOptions
                const articleOptionData = action.response.entities.articleOption

                let articleOptionsMerged = Object.assign({}, state.articleOptions, {[baseArticleData.articleNumber]: baseArticleData})

                if (articleOptionData) {

                    Object.keys(articleOptionData).forEach(articleId => {

                        let articleOptionMerged = {}

                        if (state.articleOptions[articleId]) {
                            articleOptionMerged = Object.assign({}, state.articleOptions[articleId])
                        }

                        // merge price differently since MW API has another price tag, so merge both objects
                        articleOptionMerged.price = Object.assign(
                            articleOptionMerged.price ? articleOptionMerged.price : {},
                            articleOptionData[articleId].article && articleOptionData[articleId].article.price ? articleOptionData[articleId].article.price : {},
                            articleOptionData[articleId].price ? articleOptionData[articleId].price : {},
                        )

                        articleOptionMerged.articleNumber = articleOptionData[articleId].article ? articleOptionData[articleId].article.articleNumber : false

                        articleOptionMerged.limits = articleOptionData[articleId].configurationData && articleOptionData[articleId].configurationData.limits;
                        articleOptionMerged.inclusiveLabel = articleOptionData[articleId].inclusiveLabel;

                        const articleDescriptionDefault = delve(articleOptionData[articleId], 'article.description.default');

                        if (articleDescriptionDefault) {
                            articleOptionMerged.title = articleDescriptionDefault.title;
                        } else if (delve(articleOptionData[articleId], 'title')) {
                            articleOptionMerged.title = articleOptionData[articleId].title ? articleOptionData[articleId].title : (articleOptionData[articleId].article ? articleOptionData[articleId].article.title : false)
                        }

                        if (articleDescriptionDefault) {
                            articleOptionMerged.description = articleDescriptionDefault.text;
                        }

                        articleOptionsMerged[articleId] = articleOptionMerged;

                    })

                }

                return Object.assign(state, {}, {
                    baseArticle: action.response.entities.article.baseArticle,
                    articleOptions: articleOptionsMerged,
                    articleOptionCollection: Object.assign({}, state.articleOptionCollection, action.response.entities.articleOptionCollection)
                })

            }
            return state

        case ActionTypes.ARTICLEOPTION_DATA_SUCCESS:

            let stateNew = Object.assign(state, {}, {})

            // mergo extended data into articleOptions
            if (action.response && action.response.result) {

                const articleOptionData = action.response.entities.articleOption

                // get hardware articles by preselecting hardware articles from action response
                /*const hardwareArticles = getHardwareArticles(state)*/

                Object.keys(action.response.entities.articleOption).forEach(articleId => {

                    let articleOptionMerged = Object.assign(
                        {},
                        state.articleOptions[articleId] ? state.articleOptions[articleId] : {},
                        {
                            price: Object.assign(
                                {},
                                articleOptionData[articleId].article && articleOptionData[articleId].article.price ? articleOptionData[articleId].article.price : {},
                                articleOptionData[articleId].price ? articleOptionData[articleId].price : {}
                            ),
                            contract: articleOptionData[articleId].contract ? articleOptionData[articleId].contract : (articleOptionData[articleId].article ? articleOptionData[articleId].article.contract : false),
                            billing: articleOptionData[articleId].billing ? articleOptionData[articleId].billing : (articleOptionData[articleId].article ? articleOptionData[articleId].article.billing : false)
                        }
                    )

                    articleOptionMerged.limits = articleOptionData[articleId].configurationData && articleOptionData[articleId].configurationData.limits;
                    articleOptionMerged.projectSpace = articleOptionData[articleId].projectSpace;

                    // specific for hddsw articles
                    if (delve(articleOptionData[articleId], 'article.configurationData.increaseBenefits.garbageSpaceKb')) {
                        articleOptionMerged.storageSpaceKb = delve(articleOptionData[articleId], 'article.configurationData.increaseBenefits.garbageSpaceKb');
                    }

                    //todo: awaiting fix from mittwald api
                    if (articleOptionMerged.contract.contractDuration === 0) {
                        articleOptionMerged.price.default.setupFee = articleOptionMerged.price.default.net
                        articleOptionMerged.price.default.net = 0
                    }

                    if (articleOptionData[articleId].type) {
                        articleOptionMerged.type = articleOptionData[articleId].type;
                    }

                    const articleDescriptionDefault = delve(articleOptionData[articleId], 'article.description.default');

                    if (articleDescriptionDefault) {
                        articleOptionMerged.title = articleDescriptionDefault.title;
                    } else if (delve(articleOptionData[articleId], 'description.default.title')) {
                        articleOptionMerged.title = articleOptionData[articleId].description.default.title;
                    } else if (delve(articleOptionData[articleId], 'title')) {
                        articleOptionMerged.title = articleOptionData[articleId].title;
                    }

                    if (articleDescriptionDefault) {
                        articleOptionMerged.description = articleDescriptionDefault.text;
                    } else if (delve(articleOptionData[articleId], 'description.default.text')) {
                        articleOptionMerged.description = articleOptionData[articleId].description.default.text;
                    } else if (delve(articleOptionData[articleId], 'description')) {
                        articleOptionMerged.description = articleOptionData[articleId].description;
                    }

                    const articleOptionsMerged = Object.assign({}, state.articleOptions, {[articleId]: articleOptionMerged})
                    stateNew = Object.assign(state, {}, {articleOptions: articleOptionsMerged, articleOptionCollection: Object.assign({}, state.articleOptionCollection, action.response.entities.articleOptionCollection)})

                    /* debugging: if(""+articleId==="72203") {
                        stateNew.articleOptionCollection["72203"].hardware.hddSw = Object.assign(stateNew.articleOptionCollection["72203"].hardware.hddSw, {5:"12345"})
                        stateNew.articleOptions = Object.assign(stateNew.articleOptions, {12345:{title:"12345", price:{default:{net:20, setupFee:0}}}})
                    }*/

                })

                return stateNew

            }

            return state

        default:
            return state
    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/ArticleData.js
 **/